import Download from "./Download/Download";

import './Board.css'

const Board = ({ onClick, content, type, alt_text, isHalfScreen, isFullScreen }) => {

  function handleClick(e)
  {
    e.stopPropagation()
    if(onClick) onClick()
  }

  return (
    <div className={"Board" + (isHalfScreen? " halfscreen" : "") + (isFullScreen? " fullscreen" : "")}>
      { content && <div className={"Element " + type} onClick={(e) => handleClick(e)}>
          { type === "image" && <img src={ content }/>  }
          { type === "video" && <video muted={true} ignoresilentswitch={"ignore"} autoPlay playsInline src={ content }/> }
          { type === "youtube" && <iframe id="ytplayer" className="web-media" src={content} type="text/html"/>}
          { type === "text" && <div dangerouslySetInnerHTML={{__html:content}}></div>}
          { type === "download" && <Download onClick={(e) => handleClick(e)} content={content} />}
      </div> }
      {/* { alt_text && <div className="Description">{alt_text}</div> } */}
    </div>
  );
};
export default Board